import * as xml2js from "xml2js";
import { getSfExecutionSteps } from "../services/getStepFunctionData";
import { DataCoreFlowsteps, SimEngineFlowsteps } from "./defaultValues";
import { DataCoreFlowstep, SimEngineFlowStep } from "types/Flowstep/Flowstep.interface";
import {
  getSfExecutionStepsReq as getSfExecutionStepsRequest,
  getSfExecutionStepsRes,
} from "services/getStepFunctionData";
import { ParseJsonParameter } from "types/ParseJson/ParseJson.interface";
import { ErrorInFetchingData, NoDataFound, NotApplicable } from "./constants";
import { originalConfigAccessories } from "types/ConfigurationPanel/ConfigurationPanel.interface";
import { appConfig } from "./config/appConfig";
import axios from "axios";
import { store } from "../store";
export interface LambdaMapping {
  id: number;
  errorLambda: string;
  name: string;
  step: number;
  displayStep: number;
  displayName: string;
  color: string;
  errorMsg?: string;
  error?: string;
}
export const lambdamapping: LambdaMapping[] = [
  {
    id: 1,
    name: "NSO_Request",
    errorLambda: "NSO Request",
    step: 1,
    displayStep: 1,
    displayName: "NSO Request",
    color: "#fff",
  },
  {
    id: 2,
    name: "Get_Vehicle_Data",
    errorLambda: "getVehicleData",
    step: 2,
    displayStep: 2,
    displayName: "Vehicle Details",
    color: "#fff",
  },
  {
    id: 3,
    name: "checkVehicleElgibility",
    errorLambda: "checkVehicleElgibility",
    step: 3,
    displayStep: 3,
    displayName: "Check Vehicle Eligibility",
    color: "#fff",
  },
  {
    id: 4,
    name: "Generate_Check_Digit",
    errorLambda: "GenerateCheckDigit",
    step: 5,
    displayStep: 11,
    displayName: "Generate Check Digit",
    color: "#fff",
  },
  {
    id: 5,
    name: "Get_Spec_From_Toms",
    errorLambda: "getSpecFromToms",
    step: 4,
    displayStep: 4,
    displayName: "Get Spec From Toms",
    color: "#fff",
  },
  {
    id: 6,
    name: "Get_Inline_Accessory_From_Pcps",
    errorLambda: "getInLineAccessoryFromPcps",
    step: 7,
    displayStep: 6,
    displayName: "Get Inline Accessory From Pcps",
    color: "#fff",
  },
  {
    id: 7,
    name: "Update_Non_Buildable_Spec",
    errorLambda: "UpdateNonBuildSpec",
    step: 6,
    displayStep: 5,
    displayName: "Update Non Buildable Spec",
    color: "#fff",
  },
  {
    id: 8,
    name: "Post_Order_Change_to_SimEngine",
    errorLambda: "PostOrderChangeToSimEngine",
    displayName: "Post Order Change to SimEngine",
    color: "#fff",
    step: 9,
    displayStep: 7,
  },
  {
    id: 9,
    name: "Order_Change_Response_from_SimEngine",
    errorLambda: "CheckSimEngineResponse",
    displayName: "Order Change Response from SimEngine",
    color: "#fff",
    step: 9,
    displayStep: 8,
  },
  {
    id: 10,
    name: "Post_Order_Change_Response_to_NSO",
    errorLambda: "postOrderChangeResponseToNSO",
    displayName: "Post Order Change Response to NSO",
    color: "#fff",
    step: 14,
    displayStep: 9,
  },
  {
    id: 11,
    name: "Get_Vehicle_Pricing",
    errorLambda: "GetPcpsPricing",
    displayName: "Get Vehicle Pricing",
    color: "#fff",
    step: 10,
    displayStep: 10,
  },
  {
    id: 12,
    name: "Publish_Updates_to_Vehicle_Hub",
    errorLambda: "vehiclehubWriteback",
    displayName: "Publish Updates to Vehicle Hub",
    color: "#fff",
    step: 11,
    displayStep: 11,
  },
  {
    id: 13,
    name: "Publish_Legacy_Backfill",
    errorLambda: "kafkaNvsConnection",
    displayName: "Publish Legacy Backfill",
    color: "#fff",
    step: 12,
    displayStep: 12,
  },
  {
    id: 14,
    name: "Publish_Updates_to_RTO",
    errorLambda: "rtoEvent",
    displayName: "Publish Updates to RTO",
    color: "#fff",
    step: 13,
    displayStep: 13,
  },
];
export const newNSOTranspile = async (stepStatus: string, errorLambda: string, errorMsg: string, error: string) => {
  if (stepStatus === "COMPLETE") {
    localStorage.removeItem("nsoErrorStep");
    DataCoreFlowsteps.forEach((step: DataCoreFlowstep) => {
      step.color = "#8af2a4";
      step.enabled = true;
    });
  } else if (stepStatus === "ERROR") {
    let errorStep = lambdamapping.find((lambda: any) => lambda.errorLambda === errorLambda) as LambdaMapping;
    errorStep = { ...errorStep, errorMsg, error };
    // console.log("errorStep", errorStep, error);
    localStorage.setItem("nsoErrorStep", JSON.stringify(errorStep));
    DataCoreFlowsteps.forEach((step: DataCoreFlowstep) => {
      if (step.stepId <= errorStep.step) {
        step.color = "#8af2a4";
        step.enabled = true;
      }
      if (step.stepId === errorStep.step) {
        step.color = "#fc0808";
        step.enabled = true;
      }
      if (step.stepId > errorStep.step) {
        step.color = "#fc0808";
        step.enabled = false;
      }
    });
    // DataCoreFlowsteps.forEach((newStep: DataCoreFlowstep) => {
    //   if (newStep.name === "Process VA" && newStep.color === "#fc0808") {
    //     console.log(DataCoreFlowsteps[2]);
    //     DataCoreFlowsteps[2].color = "#fc0808";
    //   }
    // });
  }
  return DataCoreFlowsteps;
};
export const newSimTranspile = async (stepStatus: string, errorLambda: string, errorMsg: string, error: string) => {
  if (stepStatus === "COMPLETE") {
    localStorage.removeItem("simErrorStep");
    SimEngineFlowsteps.forEach((step: SimEngineFlowStep) => {
      step.color = "#8af2a4";
      step.enabled = true;
    });
  } else if (stepStatus === "ERROR") {
    let errorStep = lambdamapping.find((lambda: any) => lambda.errorLambda === errorLambda) as LambdaMapping;
    errorStep = { ...errorStep, errorMsg };
    errorStep = { ...errorStep, error };
    localStorage.setItem("simErrorStep", JSON.stringify(errorStep));
    //the steps upto the error step should be green and the error step should be red and the steps after the error step should be white
    SimEngineFlowsteps.forEach((step: SimEngineFlowStep) => {
      if (step.stepId <= errorStep.step) {
        step.color = "#8af2a4";
        step.enabled = true;
      }
      if (step.stepId === errorStep.step) {
        step.color = "#fc0808";
        step.enabled = true;
      }
      if (step.stepId > errorStep.step) {
        step.color = "#fc0808";
        step.enabled = true;
      }
    });
  }
  return SimEngineFlowsteps;
};

/**
 *
 * @param xmlString
 */
export async function isValidXML(xmlString: string) {
  const parser = new DOMParser();
  const xmlDocument = parser.parseFromString(xmlString, "text/xml");

  // Check for parsing errors
  const parseError = xmlDocument.querySelectorAll("parsererror");
  if (parseError.length > 0) {
    // Handle the parsing error
    console.error("Error parsing XML:", parseError[0].textContent);
    return false;
  }
  return true;
}

/**
 *
 * @param str
 */
export async function parseXml(str: string) {
  try {
    return await xml2js.parseStringPromise(str);
  } catch {
    return false;
  }
}

/**
 *
 * @param parameter
 */
export async function parseSimEngineBody(parameter: ParseJsonParameter) {
  try {
    const parsedValue = { ...parameter, parsedJsonData: {} };
    if (parameter.type === "request") {
      const {
        // flowDetailId,
        requestId,
        urn,
        rtoId,
        modelNo,
        modelYear,
        factoryOptionList,
        ilaOptionList,
        intColor,
        extColor,
        spec200_version_1,
        spec200_version_2,
      } = parameter.jsonData;

      // parsedValue.parsedJsonData = {
      //   "VOC -> SIM Engine": {
      //     "Flow Detail ID": flowDetailId,
      //     "Request ID": requestId,
      //     URN: urn,
      //     "RTO ID": rtoId,
      //     "Model No.": modelNo,
      //     "Model Year": modelYear,
      //     "Factory Option List": factoryOptionList,
      //     "ILA Option List": ilaOptionList,
      //     "Interior Color": intColor,
      //     "Exterior Color": extColor,
      //     "Spec 200 V1": spec200_version_1,
      //     "Spec 200 V2": spec200_version_2,
      //   },
      // };
      parsedValue.parsedJsonData = {
        "Change Request To Sim Engine": {
          // "Flow Detail ID": flowDetailId,
          "Request ID": requestId,
          URN: urn,
          "RTO ID": rtoId,
          "Model No.": modelNo,
          "Model Year": modelYear,
          "Factory Option List": factoryOptionList,
          "ILA Option List": ilaOptionList,
        },
        Color: {
          Exterior: extColor,
          Interior: intColor,
        },
        Specifications: {
          "Spec 200 V1": spec200_version_1,
          "Spec 200 V2": spec200_version_2,
        },
      };
    }
    if (parameter.type === "response") {
      parsedValue.parsedJsonData = {};
    }
    return parsedValue;
  } catch (error) {
    console.log(error);
    return false;
  }
}

/**
 *
 * @param parameter
 */
export async function parseOrderChangeResponseFromSimEngineBody(parameter: ParseJsonParameter) {
  try {
    const parsedValue = { ...parameter, parsedJsonData: {} };
    if (parameter.type === "request") {
      const {
        // flowDetailId,
        // requestId,
        urn,
        rtoId,
        confirmation,
        reasonForRejection,
        modelYear,
        modelNo,
        intColor,
        extColor,
        factoryOptionList,
        ilaOptionList,
        spec200,
      } = parameter.jsonData;
      parsedValue.parsedJsonData = {
        "Vehicle Identifier": {
          // "Flow Detail ID": flowDetailId,
          // "Request ID": requestId,
          URN: urn,
          "RTO ID": rtoId,
          "Model No.": modelNo,
          "Model Year": modelYear,
          "Factory Option List": factoryOptionList,
          "ILA Option List": ilaOptionList,
          Confirmation: confirmation,
          ...(confirmation === "Rejected" && {
            "Reason for Rejection": reasonForRejection.length === 0 ? NotApplicable : reasonForRejection,
          }),
        },
        Color: {
          Exterior: extColor,
          Interior: intColor,
        },
        Specifications: {
          "Spec 200": spec200,
        },
      };
    }
    return parsedValue;
  } catch (error) {
    console.log(error);
    return false;
  }
}

/**
 *
 * @param parameter
 */
export async function parseNsoResponseBody(parameter: ParseJsonParameter) {
  // console.log("parameter.jsonDatap", parameter);
  try {
    const parsedValue = { ...parameter, parsedJsonData: {} };
    if (parameter.type === "request") {
      const { soNbr, srcSys, status, type } = parameter.jsonData;
      parsedValue.parsedJsonData = {
        "Post Data to NSO": {
          "SO Number": soNbr,
          "Source System": srcSys,
          Status: status,
          Type: type,
        },
      };
    }
    return parsedValue;
  } catch (error) {
    console.log(error);
    return false;
  }
}

/**
 *
 * @param parameter
 */
export async function parseGetPricingBody(parameter: ParseJsonParameter) {
  try {
    const parsedValue = { ...parameter, parsedJsonData: {} };
    const {
      // assessmentFlag,
      // categoryCode,
      // currentDealerCode,
      currentRegionCode,
      // dollarAssessment,
      // fioCount,
      // fleetAssessment,
      fleetIndicator,
      // fuelAdminFee,
      // fuelIndicator,
      globalPlantSourceCode,
      modelCode,
      modelCostPhase,
      // modelPhaseRecalculationFlag,
      modelPricePhase,
      // modelRepriceFlag,
      modelYear,
      // nummiStatus,
      // orderMonthNumber,
      // orderProductionMonth,
      // orderProductionYear,
      // orderYearNumber,
      // originalEstimatedBuildWeekNumber,
      // percentageAssessment,
      // portInstalledStandardOptionIndicator,
      shipToDealerCode,
      shipToRegionCode,
      // specialProgramCode,
      // vehicleAccessories,
      unpricedIndicator,
    } = parameter.jsonData;
    if (parameter.type === "request") {
      parsedValue.parsedJsonData = {
        "Vehicle Identifier": {
          "Region Code": currentRegionCode,
          "Model Code": modelCode,
          "Model Year": modelYear,
          "Model Cost Phase": modelCostPhase,
          "Model Price Phase": modelPricePhase,
          "Global Plant Source Code": globalPlantSourceCode,
          "Ship to Dealer Code": shipToDealerCode,
          "Ship to Region Code": shipToRegionCode,
          "Fleet Indicator": fleetIndicator ? "Yes" : "No",
          "Unpriced Indicator": unpricedIndicator ? "Yes" : "No",
        },
        // "Vehicle Pricing Data": {
        //   "Assessment Flag": assessmentFlag,
        //   "Category Code": categoryCode,
        //   "Dealer Code": currentDealerCode,
        //   "Dollar Assessment": dollarAssessment,
        //   "FIO Count": fioCount,
        //   "Fleet Assessment": fleetAssessment,
        //   "Fuel Admin Fee": fuelAdminFee,
        //   "Fuel Indicator": fuelIndicator,
        //   "Model Phase Recalculation Flag": modelPhaseRecalculationFlag,
        //   "Model RePrice Flag": modelRepriceFlag,
        //   "NUMMI Status": nummiStatus,
        //   "Order Month Number": orderMonthNumber,
        //   "Order Production Month": orderProductionMonth,
        //   "Order Production Year": orderProductionYear,
        //   "Order Year Number": orderYearNumber,
        //   "Original Estimated Build Week Number": originalEstimatedBuildWeekNumber,
        //   "Percentage Assessment": percentageAssessment,
        //   "Port Installed Standart Option Indicator": portInstalledStandardOptionIndicator,

        //   "Special Program Code": specialProgramCode,
        //   // "Vehicle Accessories": vehicleAccessories.map(
        //   //   (element: { accessoryCode: string; accessoryPricePhase: string }) => ({
        //   //     "Accessory Code": element.accessoryCode,
        //   //     "Accessory Price Phase": element.accessoryPricePhase,
        //   //   }),
        //   // ),
        // },
        "Factory Accessory Pricing": {
          DAPCAP: parameter.jsonData.totalFio.factoryAccessoryDAPCAP,
          "Dealer Cost": parameter.jsonData.totalFio.factoryAccessoryDealerCost,
          "Distributor Cost": parameter.jsonData.totalFio.factoryAccessoryDistributorCost,
          Holdback: parameter.jsonData.totalFio.factoryAccessoryHoldback,
          "Wholesale Finaicial Reserve": parameter.jsonData.totalFio.factoryAccessoryWholesaleFinancialReserve,
          "Suggested FIO Retail Amount": parameter.jsonData.totalFio.suggestedFIORetailAmount,
          "Total TMS Cost": parameter.jsonData.totalFio.totalFactoryAccessoryTMSCost,
        },
        "Port Installed Option": {
          "Dealer Cost": parameter.jsonData.totalPio.portInstalledOptionDealerCost,
          "Distributor Cost": parameter.jsonData.totalPio.portInstalledOptionDistributorCost,
          Holdback: parameter.jsonData.totalPio.portInstalledOptionHoldback,
          "Suggested PPO Retail Amount": parameter.jsonData.totalPio.suggestedPPORetailAmount,
        },
        // Unit: {
        //   "Total DAPCAP": parameter.jsonData.unit.totalDAPCAP,
        //   "Total Holdback": parameter.jsonData.unit.totalHoldback,
        //   "Total WFR": parameter.jsonData.unit.totalWFR,
        // },
        Model: {
          "Dealer Base Price": parameter.jsonData.model.dealerBasePrice,
          "Distributor Base Price Amount": parameter.jsonData.model.distributorBasePriceAmount,
          "Retail Base Price": parameter.jsonData.model.retailBasePrice,
          "TMS Base Cost Amount": parameter.jsonData.model.tmsBaseCostAmount,
        },
        Miscellaneous: {
          Holdback: parameter.jsonData.model.modelHoldback,
          DAPCAP: parameter.jsonData.model.modelDAPCAP,
          "Cost Phase": parameter.jsonData.modelCostPhase,
          "Price Phase": parameter.jsonData.modelPricePhase,

          // "Advertising Charge": parameter.jsonData.advertisingCharge,
          // "Delivery Processing Handling": parameter.jsonData.deliveryProcessingHandling,
          // "Fleet Program Pricing Incl Credits": parameter.jsonData.fleetProgramPricingInclCredits,
          // "Fuel Admin Fee": parameter.jsonData.fuelAdminFee,
          // "Inland Freight Charge Amount": parameter.jsonData.inlandFreightChargeAmount,
          // "Margin Adjustment Indicator": parameter.jsonData.marginAdjustmentIndicator,
        },
        "Vehicle Accessories": parameter.jsonData.vehicleAccessories.map(
          (element: { accessoryCode: string; accessoryPricePhase: string }) => ({
            "Accessory Code": element.accessoryCode,
            "Accessory Price Phase": element.accessoryPricePhase,
          }),
        ),
      };
    }
    return parsedValue;
  } catch (error) {
    console.log(error);
    return false;
  }
}

/**
 *
 * @param parameter
 */
export async function parsePublishDatacoreAndNvsBackFillbody(parameter: ParseJsonParameter) {
  try {
    // parsePublishDatacorebody
    const parsedValue = { ...parameter, parsedJsonData: { status: {} } };
    if (parameter.type === "request") {
      parsedValue.parsedJsonData.status = parameter.jsonData;
    }
    if (parameter.type === "response") {
      parsedValue.parsedJsonData.status = parameter.jsonData;
    }
    return parsedValue;
  } catch (error) {
    console.log(error);
    return false;
  }
}

/**
 *
 * @param parameter
 */
export async function parseNsoRequestBody(parameter: ParseJsonParameter) {
  try {
    const parsedValue = { ...parameter, parsedJsonData: {} };
    if (parameter.type === "request") {
      const {
        requestId,
        RTOId,
        urn,
        dealerCode,
        exteriorColor,
        interiorColor,
        modelNo,
        modelYear,
        ppoOptions,
        regionCode,
        soldOrderNo,
        userId,
      } = parameter.jsonData;
      parsedValue.parsedJsonData = {
        "NSO Request Details": {
          "Request Id.": requestId,
          "RTO Id.": RTOId,
          URN: urn,
          "Dealer Code": dealerCode,
          "Exterior Color": exteriorColor,
          "Interior Color": interiorColor,
          "Model No.": modelNo,
          "Model Year": modelYear,
          "PPO Options": ppoOptions,
          "Region Code": regionCode,
          "Sold Order No.": soldOrderNo,
          "User Id.": userId,
        },
      };
    }
    if (parameter.type === "response") {
      // parsedValue.parsedJsonData.status = param.jsonData;
    }
    return parsedValue;
  } catch (error) {
    console.log(error);
    return false;
  }
}

/**
 *
 * @param parameter
 */
export async function parseProcessDataCoreBody(parameter: ParseJsonParameter) {
  try {
    const parsedValue = { ...parameter, parsedJsonData: {} };
    if (parameter.type === "request") {
      const confirmedIlaAccessoriesSorted = await accessoriesSorter(
        parameter.jsonData.accessoryDetail ? parameter.jsonData.accessoryDetail : [],
      );
      const confirmedAccessories = confirmedIlaAccessoriesSorted.confirmedIla!.map((item: string) => item).join(", ");
      parsedValue.parsedJsonData = {
        "Vehicle Identifier": {
          "Model Year": parameter.jsonData.modelYear,
          URN: parameter.jsonData.urn,
          "Model | Serial": `${parameter.jsonData.modelCode} | ${parameter.jsonData.preProductionSerialNumber}`,
          VIN: parameter.jsonData.preProductionVIN,
          WMI: parameter.jsonData.wmi,
          "Dealer Reserved Indicator": parameter.jsonData.dealerReservedIndicator ? "YES" : "NO",
          // "Current Dealer Code": param.jsonData.currentDealer.currentDealerCode,
          "Region Code | Region Name": `${parameter.jsonData.currentDealer.currentRegionCode} | ${parameter.jsonData.currentDealer.currentRegionName}`,
          // "Region Name": parameter.jsonData.currentDealer.currentRegionName,
        },
        Color: {
          Exterior: parameter.jsonData.exteriorColor,
          Interior: parameter.jsonData.interiorColor,
        },
        "Order Information": {
          // "Actual Build Date": parameter.jsonData.vehicleDates.actualBuildDate,
          "Build Week Number": parameter.jsonData.vehicleDates.currentBuildWeekNumber,
          "Production Month": parameter.jsonData.vehicleDates.orderProductionMonth,
          "Production Year": parameter.jsonData.vehicleDates.orderProductionYear,
          "Estimated Build Date": parameter.jsonData.vehicleDates.originalEstimatedBuildDate,
          "Order Month": parameter.jsonData.order.orderMonthNumber,
        },
        "Vehicle Event": {
          "Lifecycle Status": parameter.jsonData.vehicleEvent.lifeCycleSubstatusDescription,
          // "Vehicle LifeCycle Status": parameter.jsonData.vehicleEvent.vehicleLifeCycleStatus,
          // "Vehicle LifeCycle Status Code": parameter.jsonData.vehicleEvent.vehicleLifecycleStatusCode,
        },
        // Facilities: {
        //   "Original VDC": param.jsonData.tlsFacility.originalVDC,
        //   "Order Port Entry Code": param.jsonData.order.orderPortEntryCode,
        // },
        // Accessories: {
        //   Factory: parameter.jsonData.accessoryDetail
        //     .map((item: { accessoryCode: string }) => item.accessoryCode)
        //     .join(", "),
        //   PPO: parameter.jsonData.accessoryDetail
        //     .flatMap((item: { packageSubAccessoryCode: Record<string, any> }) =>
        //       item.packageSubAccessoryCode.map(
        //         (subItem: { packageSubAccessoryCode: string }) => subItem.packageSubAccessoryCode,
        //       ),
        //     )
        //     .join(", "),
        // },
        Accessories: {
          Factory: (
            await accessoriesSorter(parameter.jsonData.accessoryDetail ? parameter.jsonData.accessoryDetail : [])
          ).factoryAccessory
            .map((item: string) => item)
            .join(", "),
          PPO: parameter.jsonData.accessoryDetail
            .flatMap((item: { packageSubAccessoryCode: Record<string, any> }) =>
              item.packageSubAccessoryCode.map(
                (subItem: { packageSubAccessoryCode: string }) => subItem.packageSubAccessoryCode,
              ),
            )
            .join(", "),
          "Confirmed ILA": confirmedAccessories,
        },
      };
    }
    // console.log(
    //   "",
    //   await accessoriesSorter(parameter.jsonData.accessoryDetail ? parameter.jsonData.accessoryDetail : []),
    // );
    return parsedValue;
  } catch (error) {
    console.log(error);
    return false;
  }
}

/**
 *
 * @param parameter
 */
export async function parseCheckVehicleEligibilityBody(parameter: ParseJsonParameter) {
  try {
    const parsedValue = { ...parameter, parsedJsonData: {} };
    if (parameter.type === "request") {
      const {
        regionCode,
        dealerCode,
        vehicleLifeCycleStatus,
        currentDealerCode,
        currentRegionCode,
        dealerReservedIndicator,
        modelYear,
        urn,
        modelNo,
      } = parameter.jsonData;

      parsedValue.parsedJsonData = {
        "Vehicle Identifier": {
          "Model Year": modelYear,
          "Model No.": modelNo,
          URN: urn,
          "Region Code": regionCode,
          "Dealer Code": dealerCode,
          "Vehicle Lifecycle Status": vehicleLifeCycleStatus,
          "Current Dealer Code": currentDealerCode,
          "Current Region Code": currentRegionCode,
          "Dealer Reserve Indicator": dealerReservedIndicator,
        },
      };
    }
    return parsedValue;
  } catch (e) {
    console.log(e);
    return false;
  }
}

/**
 *
 * @param parameter
 */
export async function parseGenerateCheckDigitBody(parameter: ParseJsonParameter) {
  try {
    const parsedValue = { ...parameter, parsedJsonData: {} };
    const { oldVinCheckDigit, oldSerialCheckDigit, oldPreProdVin, vinCheckDigit, serialCheckDigit, preProdVin } =
      parameter.jsonData;
    if (parameter.type === "request") {
      parsedValue.parsedJsonData = {
        "Vehicle Identifier": {
          "Vin Check Digit": oldVinCheckDigit,
          "Serial Check Digit": oldSerialCheckDigit,
          "Pre Prod Vin": oldPreProdVin,
          ...(vinCheckDigit && {
            "New Vin Check Digit": vinCheckDigit.length === 0 ? NotApplicable : vinCheckDigit,
          }),
          ...(serialCheckDigit && {
            "New Serial Check Digit": serialCheckDigit.length === 0 ? NotApplicable : serialCheckDigit,
          }),
          ...(preProdVin && {
            "New Pre Prod Vin": preProdVin.length === 0 ? NotApplicable : preProdVin,
          }),
        },
      };
    }
    return parsedValue;
  } catch (e) {
    console.log(e);
    return false;
  }
}

/**
 *
 * @param parameter
 */
export async function parseProcessTOMSBody(parameter: ParseJsonParameter) {
  try {
    const parsedValue = {
      parsedJsonData: {},
    };

    if (parameter.type === "request") {
      const { jsonData } = parameter;
      parsedValue.parsedJsonData = {
        "Vehicle Identifier": {
          "Distributor Code": jsonData.dsCd,
          // "Division Code": jsonData.dvCd,

          "Model Code": jsonData.model,
          "Model Year": jsonData.my,
          "Plant Code": jsonData.plCd,
          "Port Code": jsonData.ptCd,
          "Region ID": jsonData.regId,
          "Required Date": jsonData.reqDt,
          // "User ID": jsonData.userId,

          VDS: jsonData.VDS_ID,
          WMI: jsonData.WMI,
          // "Catalog ID": jsonData.catalogId,
          // "Distributor Code": jsonData.distributor_cd,
          // "Division Code": jsonData.division_cd,
          "Japan Model No.": `${jsonData.katashiki_name}`,
          // Katashiki: jsonData.katashiki,
          "Katashiki Name": jsonData.katashiki_name,
          // "Model Year": jsonData.model_year_no,
          // "Port Code": jsonData.portCd,
          // "Region Port Id.": jsonData.region_port_id,

          SSN: jsonData.ssn,
          Status: jsonData.status,
          "Sub Series Code": jsonData.subseriescode,
          // "TMSM NM": jsonData.tmsm_nm,
          // TOKUSETSU: jsonData.tokusetsu,
          // "Trim Code": jsonData.trimcode,
          // Valid: jsonData.valid,
        },
        Color: {
          Exterior: jsonData.ec,
          Interior: jsonData.ic,
        },
        // Accessories: {},
        Specifications: {
          "Spec 200": jsonData.spec_200,
        },
      };
    }

    return parsedValue;
  } catch (error) {
    console.log(error);
    return false;
  }
}

/**
 *
 * @param parameter
 */
export async function parseUpdateNonBuildableSpecbody(parameter: ParseJsonParameter) {
  try {
    // console.log(parameter);
    const parsedValue = { ...parameter, parsedJsonData: {} };
    const { nonBuildSpec, spec200V1, spec200V2, modelYear, urn } = parameter.jsonData;
    if (parameter.type === "request") {
      parsedValue.parsedJsonData = {
        ...(modelYear && {
          "Vehicle Identifier": {
            "Model Year": modelYear,
            URN: urn,
          },
        }),
        "Gas Spec": {
          "Spec Code": nonBuildSpec.gasSpec.specCode,
          "Spec Position": nonBuildSpec.gasSpec.specPos,
        },
        "License Plate": {
          "Spec Code": nonBuildSpec.licensePlate.specCode,
          "Spec Position": nonBuildSpec.licensePlate.specPos,
        },
        "Rap Guard Spec": {
          "Spec Code": nonBuildSpec.rapguardSpec.specCode,
          "Spec Position": nonBuildSpec.rapguardSpec.specPos,
        },
        Specifications: {
          "Spec 200 V1": spec200V1,
          "Spec 200 V2": spec200V2,
        },
      };
    }
    return parsedValue;
  } catch (error) {
    console.log(error);
    return false;
  }
}

/**
 *
 * @param parameter
 */
export async function parseILAFetchBody(parameter: ParseJsonParameter) {
  try {
    const parsedValue = { ...parameter, parsedJsonData: {} };
    if (parameter.type === "request") {
      const { modelCode, modelYear, originalVDC, response_json, validIlaDetails, requestedConfig } = parameter.jsonData;
      const ilaOptionSet = new Set();
      validIlaDetails.validIlaDetails.forEach((element: any) => {
        ilaOptionSet.add(element.accessoryCode);
      });
      parsedValue.parsedJsonData = {
        "Requested Configuration": {
          "Model Code": modelCode,
          "Model Year": modelYear,
          "Original VDC": originalVDC,
          "Factory ": requestedConfig.factoryOptions,
          "PPO ": requestedConfig.ppoOptions,
          // "Accessory Codes": vehicleAccessories.map((item: { accessoryCode: string }) => item.accessoryCode).join(", "),
        },
        // "Vehicle Accessories": vehicleAccessories.map((element: { accessoryCode: string }) => ({
        //   "Accessory Code": element.accessoryCode,
        // })),
        "Inline Accessories From PCPS": response_json.ILAArray.map(function (element: {
          ilaAccessoryCode: string;
          specCode: string[];
        }) {
          return element.specCode.map(function (specCode: string) {
            // const specCode = element.specCode.toString();
            const lastCharacter = specCode.charAt(specCode.length - 1);
            const specPosition = specCode.slice(0, -1);
            return {
              "Accessory Code": element.ilaAccessoryCode,
              "Spec Code | Spec Position": `${lastCharacter} | ${specPosition}`,
            };
          });
        }),
        "Confirmed ILA": { "Valid ILA": [...ilaOptionSet].join(", ") },
      };
    }
    return parsedValue;
  } catch (error) {
    console.log(error);
    return false;
  }
}

/**
 *
 * @param parameter
 */
export async function parseJson(parameter: ParseJsonParameter) {
  try {
    // console.log("Parsing function call; Before Parsing data", parameter);
    let parsedValue: { parsedJsonData: Record<string, any> } | false = {
      parsedJsonData: {},
    };
    if (parameter.key !== "NSO_Request" && typeof parameter.jsonData === "string") {
      parsedValue.parsedJsonData = { Status: parameter.jsonData };
      return parsedValue;
    }
    if ("Status" in parameter.jsonData && parameter.jsonData.Status == NoDataFound) {
      parsedValue.parsedJsonData = parameter.jsonData;
      return parsedValue;
    }
    if (typeof parameter.jsonData === "object" && "errors" in parameter.jsonData) {
      // parsedValue = {
      //   parsedJsonData: {
      //     Error: parameter.jsonData.errors.map((element: { message: string }) => ({
      //       "Error Messag ": element.message,
      //     })),
      //   },
      // };
      parsedValue = {
        parsedJsonData: {},
      };
      return parsedValue;
    }
    if (parameter.page === "simengineflow") {
      switch (parameter.key) {
        case "Order_Change_Response_from_SimEngine": {
          parsedValue = await parseOrderChangeResponseFromSimEngineBody(parameter);
          break;
        }
        case "Post_Order_Change_Response_to_NSO": {
          parsedValue = await parseNsoResponseBody(parameter);
          break;
        }
        case "Generate_Check_Digit": {
          parsedValue = await parseGenerateCheckDigitBody(parameter);
          break;
        }
        case "Get_Vehicle_Pricing": {
          parsedValue = await parseGetPricingBody(parameter);
          break;
        }
        case "Publish_Updates_to_Vehicle_Hub": {
          parsedValue = await parsePublishDatacoreAndNvsBackFillbody(parameter);
          break;
        }
        case "Publish_Legacy_Backfill": {
          parsedValue = await parsePublishDatacoreAndNvsBackFillbody(parameter);
          break;
        }
        default: {
          parsedValue.parsedJsonData = { Status: parameter.jsonData };
        }
      }
    }
    if (parameter.page === "datacoreflow") {
      switch (parameter.key) {
        case "NSO_Request": {
          parsedValue = await parseNsoRequestBody(parameter);
          break;
        }
        case "Get_Vehicle_Data": {
          parsedValue = await parseProcessDataCoreBody(parameter); // Pending
          break;
        }
        case "checkVehicleElgibility": {
          parsedValue = await parseCheckVehicleEligibilityBody(parameter);
          break;
        }
        case "Get_Spec_From_Toms": {
          parsedValue = await parseProcessTOMSBody(parameter);
          break;
        }
        case "Update_Non_Buildable_Spec": {
          parsedValue = await parseUpdateNonBuildableSpecbody(parameter); // Pending
          break;
        }
        case "Get_Inline_Accessory_From_Pcps": {
          parsedValue = await parseILAFetchBody(parameter);
          break;
        }
        case "Post_Order_Change_to_SimEngine": {
          parsedValue = await parseSimEngineBody(parameter);
          break;
        }
        default: {
          parsedValue = {
            parsedJsonData: { Status: parameter.jsonData },
          };
        }
      }
    }
    // console.log("Parsing function call; After Parsing data", parsedValue);
    if (parsedValue === false) {
      parsedValue = {
        parsedJsonData: {},
      };
    }
    return parsedValue;
  } catch (error) {
    console.log(error);
    return false;
  }
}

export const handleSimEngineStepFunctionData = async ({
  flowDetailId,
  flowSimStatus,
}: {
  flowDetailId: string;
  flowSimStatus: string;
}) => {
  const data = await getSfExecutionSteps({ flowDetailId });
  if (typeof data === "boolean") {
    if (data === false) {
      console.log(ErrorInFetchingData);
      return false;
    }
  } else if (data.statusCode === 200 && data.payload[0]?.errors.flowStatus === NoDataFound) {
    console.log(NoDataFound);
  } else {
    //const lastStep: { flowDetailId: number; stepId: number; successId?: number[]; errorId?: number[] } =
    //data.payload[0].steps.at(-1)!;
    //lastStep[flowSimStatus === "COMPLETE" ? "successId" : "errorId"] = [2, 3, 4];
    // console.log("modifiedData", modifiedData);
    return await newSimTranspile(
      flowSimStatus,
      data.payload[0]?.errors?.errorLambda || "",
      data.payload[0]?.errors?.errorDescription?.msg || "",
      data.payload[0]?.errors?.errorDescription?.error || "",
    );
  }
};

export const handleNsoStepFunctionData = async ({
  flowDetailId,
  flowNsostatus,
}: {
  flowDetailId: string;
  flowNsostatus: string;
}) => {
  const data = await getSfExecutionSteps({ flowDetailId });
  if (typeof data === "boolean") {
    if (data === false) {
      console.log(ErrorInFetchingData);
      return false;
    }
  } else if (data.statusCode === 200 && data.payload[0]?.errors?.flowStatus === NoDataFound) {
    console.log(NoDataFound);
  } else {
    // console.log("Transpile payload", data.payload);

    return newNSOTranspile(
      flowNsostatus,
      data.payload[0]?.errors?.errorLambda || "",
      data.payload[0]?.errors?.errorDescription?.msg || "",
      data.payload[0]?.errors?.errorDescription?.error || "",
    );
  }
};

export const handleStepFunctionData = async (
  id: string,
  stepFunctionData: SimEngineFlowStep[] | DataCoreFlowstep[],
  flowNsoStatus: string,
  setStepFunctionData: React.Dispatch<React.SetStateAction<any>>,
): Promise<void> => {
  try {
    const data = await getSfExecutionSteps({ flowDetailId: id });
    if (typeof data === "boolean") {
      if (data === false) {
        console.log(ErrorInFetchingData);
      }
    } else if (data.statusCode === 200 && data.payload[0]?.errors?.flowStatus === NoDataFound) {
      console.log(NoDataFound);
    } else {
      const errorLambda = data.payload[0]?.errors?.errorLambda || ""; // Add null check and default value
      const modifiedData = await newNSOTranspile(
        flowNsoStatus,
        errorLambda,
        data.payload[0]?.errors?.errorDescription?.msg || "",
        data.payload[0]?.errors?.errorDescription?.error || "",
      );
      setStepFunctionData(modifiedData);
    }
  } catch (e) {
    console.log(e);
  }
};

export const accessoriesSorter = async (existingAccessories: any[]): Promise<originalConfigAccessories> => {
  const accessories: originalConfigAccessories = {
    factoryAccessory: [],
    ppoAccessory: [],
    confirmedIla: [],
  };

  let newAccessories = existingAccessories;
  newAccessories = newAccessories.filter(
    (accessory: { accessorySequenceNumber: number | null }) => accessory.accessorySequenceNumber !== null,
  );
  newAccessories?.sort(
    (a: { accessorySequenceNumber: number | null }, b: { accessorySequenceNumber: number | null }) => {
      if (a.accessorySequenceNumber === null) return -1;
      if (b.accessorySequenceNumber === null) return 1;
      return a.accessorySequenceNumber - b.accessorySequenceNumber;
    },
  );
  const factoryAccessory = newAccessories.filter((item) => item.accessoryType === "F");
  const ppoAccessory = newAccessories.filter((item) => item.accessoryType === "P");
  factoryAccessory.forEach((accessory: { accessoryCode: string }) => {
    accessories.factoryAccessory.push(accessory.accessoryCode);
  });
  ppoAccessory.forEach((accessory: { accessoryCode: string }) => {
    accessories.ppoAccessory.push(accessory.accessoryCode);
  });
  ppoAccessory.forEach((accessory: { accessoryCode: string; accessoryInstallationStatus: string }) => {
    if (accessory.accessoryInstallationStatus === "Inline Pending") {
      accessories.confirmedIla?.push(accessory.accessoryCode);
    }
  });
  // console.log("factoryAccessory", factoryAccessory);
  // console.log("ppoAccessory", ppoAccessory);

  // const accessoryCodes: string[] = [];
  // accessories.forEach((accessory: Acc) => {
  //   accessoryCodes.push(...accessory.factoryAccessory, ...accessory.ppoAccessory);
  // });
  // console.log("accessoryCodes", accessories);
  return accessories;
};

export const fetchData = async (
  id: string,
  setRequestedConfig: React.Dispatch<React.SetStateAction<any>>,
  setOriginalConfig: React.Dispatch<React.SetStateAction<any>>,
  setOriginalConfigAccessories: React.Dispatch<React.SetStateAction<originalConfigAccessories>>,
  setFlowChartLoader: React.Dispatch<React.SetStateAction<boolean>>,
): Promise<void> => {
  try {
    const requestedConfigVal = await getSfExecutionStepsRequest({
      flowDetailId: id,
      stepId: "1",
    });
    setRequestedConfig(requestedConfigVal.payload[0].request_json);

    const originalConfigVal = await getSfExecutionStepsRes({
      flowDetailId: id,
      stepId: "2",
    });
    setOriginalConfig(originalConfigVal.payload[0].response_json);

    const accessories: any = await accessoriesSorter(
      originalConfigVal.payload[0]?.response_json?.accessoryDetail
        ? originalConfigVal.payload[0]?.response_json?.accessoryDetail
        : [],
    );
    setOriginalConfigAccessories(accessories);

    setFlowChartLoader(false);
  } catch (error) {
    console.error("An error occurred:", error);
  }
};

const reqResConfig = (flowId: any, stepId: any) => {
  const state = store.getState();
  const { idToken } = state.auth.auth;
  return {
    method: "post",
    url: appConfig.sf_execution_steps_req_url,
    headers: {
      "Content-Type": "application/json",
      Authorization: idToken,
    },
    data: {
      flowDetailId: flowId,
      stepId: stepId,
    },
  };
};
export const fetchRequestResponseData = async (id: string, stepId: string) => {
  const response = await axios(reqResConfig(id, stepId));
  if (response.status === 200) {
    return response.data.payload[0];
  }
  return false;
};

/**
 *
 * @param parameter
 */
export async function parsePublishUpdatesToVehicleHubbody(parameter: ParseJsonParameter) {
  try {
    // parsePublishDatacorebody
    const parsedValue = { ...parameter, parsedJsonData: {} };
    // console.log("parameter.jsonData", parameter);
    const { metadata, payload } = parameter.jsonData;
    const {
      key,
      modelCode,
      vehicleColorTrim,
      vds,
      preProductionVIN,
      modelPricePhase,
      preProductionSerialCheckDigitNumber,
      wmi,
      vehiclePrice,
      factoryAccessories,
      ppoAccessories,
      ila,
    } = payload[0];
    const formatterVehiclePrice: { [key: string]: string } = {};
    const formatterVehicleColorTrim: { [key: string]: string } = {};
    if (vehiclePrice) {
      Object.keys(vehiclePrice).forEach((key) => {
        const formattedKey = key
          .replace(/([A-Z])/g, " $1")
          .trim()
          .replace(/^./, (str) => str.toUpperCase());
        formatterVehiclePrice[formattedKey] = vehiclePrice[key];
      });
    }
    if (vehicleColorTrim) {
      Object.keys(vehicleColorTrim).forEach((key) => {
        const formattedKey = key
          .replace(/([A-Z])/g, " $1")
          .trim()
          .replace(/^./, (str) => str.toUpperCase());
        formatterVehicleColorTrim[formattedKey] = vehicleColorTrim[key];
      });
    }
    if (parameter.type === "request") {
      parsedValue.parsedJsonData = {
        "Vehicle Identifier": {
          URN: key.urn,
          "Model Year": key.modelYear,
          ...(modelCode && { "Model Code": modelCode }),
          ...(vds && { VDS: vds }),
          ...(preProductionVIN && { "Pre Production VIN": preProductionVIN }),
          ...(modelPricePhase && { "Model Price Phase": modelPricePhase }),
          ...(preProductionSerialCheckDigitNumber && {
            "Pre Production Serial Check Digit": preProductionSerialCheckDigitNumber,
          }),
          ...(wmi && { WMI: wmi }),
        },
        ...(vehiclePrice && {
          "Vehicle Price": { ...formatterVehiclePrice },
        }),
        ...(vehicleColorTrim && {
          "Vehicle Color": { ...formatterVehicleColorTrim },
        }),
        ...(factoryAccessories && {
          "Factory Accessories": factoryAccessories.map(function (element: { code: string }) {
            return element.code;
          }),
        }),
        ...(ppoAccessories && {
          "PPO Accessories": ppoAccessories.map(function (element: { code: string }) {
            return element.code;
          }),
        }),
        ...(ila && {
          ILA: ila.map(function (element: { code: string }) {
            return element.code;
          }),
        }),
        Metadata: {
          "Event Domain": metadata.eventDomain,
          "Source System": metadata.sourceSystem,
          "User ID": metadata.userId,
          GUID: metadata.GUID,
          "Event Type": metadata.eventType,
          "Issue Time": metadata.issueTime,
        },
      };
    }
    return parsedValue;
  } catch (error) {
    console.log(error);
    return false;
  }
}
